// extracted by mini-css-extract-plugin
module.exports = {"TwoDimsFeature":"vv_a bha_b bha_ux"};